enum AreaSubmodule {
  INSTITUTIONAL = 0x00000100,
  PHYSICAL = 0x00000200,
}

export { AreaSubmodule };
